import { render, staticRenderFns } from "./goodsoption.vue?vue&type=template&id=c8c85980&"
import script from "./goodsoption.vue?vue&type=script&lang=js&"
export * from "./goodsoption.vue?vue&type=script&lang=js&"
import style0 from "./goodsoption.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports